import React from "react";
import { Navigate, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { useProfile } from "../Hooks/UserHooks";

// Mirrors Sidebar.js's SUPERADMIN_ONLY_LABELS — hiding a sidebar link
// doesn't stop someone typing the URL directly, so a store-tied admin
// (role "admin") gets redirected away from these even on direct navigation.
// Path prefixes, matched case-insensitively against the current pathname.
const SUPERADMIN_ONLY_PATH_PREFIXES = [
  "/category", "/variants", "/cities", "/stores", "/catalog", "/app-settings", // Masters
  "/users", "/payments", "/admin-settings", // Administration
  "/banners", // Banners
  "/developer-tools", // Developer
];

const AuthProtected = (props) => {
  const userRole = useSelector((state) => state?.login?.role);
  const usernameAd = useSelector((state) => state?.login?.user);
  const { userProfile, loading } = useProfile();
  const location = useLocation();

  const token = localStorage.getItem('token');


  /*
    redirect is un-auth access protected routes via url
    */

  if (!token || userRole === null || usernameAd === null) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  if (userRole === "admin") {
    const pathname = (location.pathname || "").toLowerCase();
    const isRestricted = SUPERADMIN_ONLY_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
    if (isRestricted) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
